module.exports = __webpack_public_path__ + "static/host-headshot-photo.b54ad8fe.webp";